/**
 * A data-base dos dois cards de venda, dita na própria ajuda deles.
 *
 * Isto é do painel LEGADO. O painel novo já diz a base nos dois cards ("Vendas efetivamente pagas no
 * período, pela data do pagamento" e o cruzamento com "valor gerado"), e o legado não dizia nada: a
 * ajuda só repetia o número e a variação. Quem comparava 25 vendas com "26 pagas de 38 geradas" só
 * encontrava explicação abrindo o `?` do OUTRO card, que já explicava a assimetria do lado dele.
 * Chegou como dúvida de cliente, não como bug — as duas coortes são diferentes de propósito.
 *
 * Uma constante, e não a frase escrita duas vezes: quantidade e valor têm a mesma base, e o dia em
 * que uma delas for corrigida sozinha é o dia em que a ajuda passa a mentir num dos dois.
 *
 * **Diz a base DESTE card, e não menciona o card de taxa de pagamento.** É tentador escrever "é por
 * isso que não bate com a taxa de pagamento", só que aquele bloco é escondido de afiliado
 * (`DashboardCard`, e a API recusa o papel): a frase mandaria comparar com um card que não está na
 * tela, ao lado do aviso que diz que ele não se aplica. Cada card afirma a SUA base; o cruzamento
 * fica no card que existe nas duas situações.
 *
 * Fala só da coorte, que é a diferença grande. Vendas também conta apenas a primeira parcela e
 * ignora comissão bloqueada, e as duas só encolhem Vendas — cabem na resposta do suporte a quem
 * reconcilia item por item, não numa frase de hover que fica longa e deixa de ser lida.
 */
const BASE_DE_DATA =
  'A venda entra na conta pela data do pagamento: uma cobrança gerada ontem e paga hoje conta em hoje, não em ontem.';

export const getDefaultMessage = (
  type:
    | 'salesCountInfo'
    | 'salesValueInfo'
    | 'refundsCountInfo'
    | 'refundsValueInfo'
    | 'newUsersInfo',
  newValue: number,
  totalValue: number,
  percentage: number | string,
  newLabel?: string,
  title?: string,
) => {
  const parsedPercentage = parsePercentage(Number(percentage));
  const percentageVariation =
    Number(parsedPercentage) > 1
      ? `um aumento de (${parsedPercentage}%)`
      : `uma queda de (${parsedPercentage * -1}%)`;

  switch (type) {
    case 'salesCountInfo':
      return `Suas comunidades tiveram ${newValue} novas vendas no período escolhido, representando ${percentageVariation} em comparação com o período anterior, que teve ${totalValue} vendas. ${BASE_DE_DATA}`;

    case 'salesValueInfo':
      return `Suas comunidades tiveram um valor de vendas de R$${newValue} no período escolhido, representando ${percentageVariation} em comparação com o período anterior, que teve R$${totalValue} em vendas. ${BASE_DE_DATA}`;

    case 'refundsCountInfo':
      return `Suas comunidades tiveram ${newValue} novos reembolsos no período escolhido, representando ${percentageVariation} em comparação com o período anterior, que teve ${totalValue} reembolsos.`;

    case 'refundsValueInfo':
      return `Suas comunidades tiveram um valor de reembolsos de ${newValue} no período escolhido, representando ${percentageVariation} em comparação com o período anterior, que teve R$${totalValue} em reembolsos.`;

    case 'newUsersInfo':
      return `Suas comunidades tiveram ${newValue} (${percentage}%)  ${newLabel} no período escolhido, de um total de ${totalValue} ${title}.`;

    default:
      return 'No default message matches this chart type';
  }
};

const parsePercentage = (percentage: number) => {
  if (percentage === Infinity) return 100;
  if (percentage === -Infinity) return -100;
  return +percentage;
};
